import { createContext, useContext } from 'react';
export var SearchHistoryContext = createContext({
    item: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSelect: function () { },
});
SearchHistoryContext.displayName = 'SearchHistoryContext';
export var SearchHistoryContextProvider = SearchHistoryContext.Provider;
export var useSearchHistoryContext = function () { return useContext(SearchHistoryContext); };
